module.exports = __webpack_public_path__ + "media/luxury-2026/estate-arrival-roof-cleaned-ef023baf.jpg";